/**
 * autocreated commitinfo by @pushrocks/commitinfo
 */
export const commitinfo = {
  name: '@losslessone_private/account.workspace.global',
  version: '1.0.52',
  description: 'website for lossless.com'
}
